<template>
  <label class="group-label" for="height">Height</label>
  <fieldset id="height">
    <br />
    <div v-if="units === 'metric'">
      <el-input-number id="cm" v-model="cm" :min="0"></el-input-number>
      <label for="cm">cm</label>
    </div>
    <div v-if="units === 'imperial'">
      <el-input-number id="feet" v-model="feet" :min="0"> </el-input-number>
      <label for="feet">ft</label>
      <el-input-number id="inches" v-model="inches"> </el-input-number>
      <label for="inches">in</label>
    </div>
  </fieldset>
</template>

<script type="ts">
import {
  feetAndInchesToCm,
  cmToWholeFeet,
  cmToWholeInches,
} from "@/utils/conversions.js"

export default {
  name: "HeightFieldset",
  props: ["units", "height"],
  emits: {
    "change-height"(payload) {
      return !!payload.height
    },
  },
  data() {
    return {
      cm: this.height,
    }
  },
  computed: {
    feet: {
      get: function () {
        return cmToWholeFeet(this.cm)
      },
      set: function (newFeet) {
        this.cm = feetAndInchesToCm(newFeet, this.inches)
      },
    },
    inches: {
      get: function () {
        return cmToWholeInches(this.cm)
      },
      set: function (newInches) {
        this.cm = feetAndInchesToCm(this.feet, newInches)
      },
    },
  },
  updated() {
    this.$emit("change-height", { height: this.cm })
  },
}
</script>

<style scoped>
</style>